import React from 'react'
import PropTypes from 'prop-types'
import CookieConsent from 'react-cookie-consent'
import Header from './header'
import Footer from './footer'
import CTA from './sections/cta'
import styles from './layout.module.scss'

const Layout = ({ children }) => (
  <div className={ styles.layout }>
    <Header />

    <main className={ styles.main }>
      { children }
    </main>

    <CTA
      title="Interested in the Rheia system?"
      link="/contact"
      linkText="Contact us to get started"
      linkColor="#E8FAFF"
      marginBottom={ false }
      textColor="#E8FAFF"
      backgroundColor="#0071BC"
    />

    <Footer />

    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="gatsby-gdpr-google-analytics"
      containerClasses={ styles.consent }
      contentClasses={ styles.consentContent }
      buttonClasses={ styles.consentAccept }
      disableStyles={ true }
      disableButtonStyles={ true }
      enableDeclineButton={ true }
      declineButtonClasses={ styles.consentDecline }
    >
      We use cookies to improve your experience on our site and to show you relevant advertising. To find out more, read our privacy policy.
    </CookieConsent>
  </div>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
